import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { t } from "i18next";
import { AppStandardButton } from "../components/UI/AppButtons";

export default function AlertMessage({
  openModal,
  requestOnClose,
  modalMessage,
  maxWidth,
}: {
  openModal: boolean;
  requestOnClose: () => void;
  modalMessage: string;
  // Optional per-caller width cap. Left unset by default so existing callers
  // keep MUI's default sizing (~600px) rather than being forced into a width
  // only one caller actually asked for.
  maxWidth?: string;
}) {
  return (
    <Dialog
      open={openModal}
      onClose={requestOnClose}
      aria-labelledby="alert-dialog-title"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "20px",
          minWidth: { sm: "400px" },
          ...(maxWidth ? { maxWidth, width: "100%" } : {}),
        },
      }}
    >
      <DialogTitle id="alert-dialog-title" style={{ padding: "2rem" }}>
        {modalMessage}
      </DialogTitle>

      <DialogActions>
        <AppStandardButton variant="outlined" onClick={requestOnClose}>
          <p className="text-black normal-case">{t("Close")}</p>
        </AppStandardButton>
      </DialogActions>
    </Dialog>
  );
}
